import { advertiserApi } from 'common/api/entitiesApi'
import React from 'react'
import { OwnedEntitySelector } from 'common/components/reloadable/OwnedEntitySelector.tsx'

export interface Props {
    agencyId?: number
    value?: number
    onChange?: (value?: number | number[]) => void
    style?: React.CSSProperties
    disabled?: boolean
    placeholder?: string
    multiple?: boolean
}

export const AdvertiserSelector = ({agencyId, value, onChange, style, disabled, placeholder, multiple}: Props) => {

    function findEntity(id: number) {
        return advertiserApi.adv(id)
    }

    function searchEntities(search: string, size: number, page: number, agencyId: number) {
        return advertiserApi.advPage('name', 'asc', search, undefined, undefined, agencyId, {query: {size, page}})
    }

    return <OwnedEntitySelector
        ownerId={agencyId}
        value={value}
        onChange={onChange}
        loadEntity={findEntity}
        searchEntities={searchEntities}
        placeholder={placeholder}
        disabled={disabled}
        style={style}
        errorText="Can't load Advertisers"
        multiple={multiple}
    />
}